
import { ACTION_OPEN_MODAL } from '../../store/actions/sidebar'
import { createNamespacedHelpers } from 'vuex'
import { loadSectionTranslations } from '../../i18n-setup'
const { mapActions } = createNamespacedHelpers('sidebar')

export default {
  name: 'SghCountrySelector',
  props: {
    infoCountry: {
      type: Object,
      default: () => {},
    },
    componentPosition: {
      type: String,
      default: '',
    },
  },
  mounted() {
    loadSectionTranslations('cms')
    window.externalInvocationMethodMapping.initCountrySelector = () => {
      try {
          this.openModalCountrySelector()
      } catch (e) {
        throw new Error('error in initCountrySelector function',e)
      }
    }
  },
  methods: {
    ...mapActions({
      openModal: ACTION_OPEN_MODAL,
    }),
    openModalCountrySelector() {
      document.querySelector('.sgh-header').classList.add('country-selector-layer')
      this.openModal({ isModalOpen: true, componentName: 'sgh-country-selector-list' })
    },
  },
}
